
import React, { useState } from 'react'
import axios from 'axios'
import { baseApiURL } from 'src/utils/utils'
import styles from './frontpage.module.scss'
import Input from 'src/components/input/Input'
import Button from 'src/components/button/Button'
import { validEmail, handleValidation } from 'src/utils/utils'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router'

const ResetPassword: React.FunctionComponent = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState({ email: false })
  const [isLoading, setIsLoading] = useState(false)
  const history = useHistory()

  const passwordReset = (e) => {
    e.preventDefault();
    setIsLoading(true)
    axios.put(`${baseApiURL()}/users/forgot_password`,{email})
      .then(() => {
        setIsLoading(false)
        history.push('/login')
        toast('Vi har sendt en email til dig')
      })
      .catch((err) => {
        toast(err.response.data.message)
        setIsLoading(false)
      })
  }

  return (
    <>
      <div className={styles.module}>
        <form onSubmit={passwordReset}>
          <Input
            name='email'
            label='E-mail'
            error={error.email}
            value={email}
            resetError={() => setError({ email: false })}
            handleValidation={() => handleValidation(validEmail, 'email', setError, error)}
            handleInputChange={() => setEmail}
            placeholder='Indtast din arbejdsmail'
            type='text'
          />
          {error.email && <p className='errorMsg'>Emailen ser ikke ud til at være i et korrekt format.</p>}
          <Button
            label='Send e-mail'
            type='primary'
            submit={true}
            loading={isLoading}
            modifiers='tw-mt-8 tw-w-full tw-justify-center'
            disabled={(error.email || !email)}
          />
        </form>
      </div>
    </>
  )
}

export default ResetPassword